import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Typography, InputLabel, TextField, Button} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CircularProgress from '@mui/material/CircularProgress';
import {Dialog, DialogTitle, DialogContent} from "@mui/material";
import { getLDAPUserBySearchField } from "../../components/Api/Getters";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const pageHeight = `calc(100vh - calc(13rem + 8px))`;
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


export default function DesigneeForm() {

    const [ddcInfoFetched,setDdcInfoFetched] = useState(null)
    const [loaded,setLoaded] = useState(false)
    const [ddcInfo,setDdcInfo] = useState({})
    const [designeeCCID,setDesgineeCCID] = useState("")
    const [searchStatus, setSearchStatus] = useState("");
    const [desgineeInfo,setDesigneInfo] = useState(null)
    const [accessLevel, setAccessLevel] = useState("report");
    const [loadingMessage,setLoadingMesasge] = useState(false)
    const [loadingWheel,setLoadingWheel] = useState(false)
    const [insertSuccess,setInsertSuccess] = useState(false)
    const [insertError,setInsertError] = useState(false)
    const [ddcExists,setDdcExists] = useState(false)
    const [updatedValues,setUpdatedValues] = useState(false)


    useEffect(() => {
            let url = process.env.REACT_APP_BACKEND_HOST;
            async function collect_ddc_info() {
                const response = await fetch(url.concat("/spot/ddc_info/", sessionStorage.ccid, "/"), {
                    headers: { Authorization: `Token ${sessionStorage.token}` },
                });
                const apiData = await response.json();
                setDdcInfoFetched(true);
                return apiData;
            }
               
            if (!ddcInfoFetched) {
                let apiData = [collect_ddc_info()];
                Promise.all(apiData).then((values) => {
                    let data = values[0];
                    setDdcInfo(data)
                    setLoaded(true)
                })
    
            }
        }, [loaded, ddcInfoFetched]);


    const handleCCIDsearchInput = (event) => {
		setDesgineeCCID(event.target.value);
	};

    const searchCCID = async () => {
        setUpdatedValues(false)
        try{
            const response = await fetch(process.env.REACT_APP_BACKEND_HOST.concat("/spot/checkExistingDDC/",designeeCCID,"/"), {
            method: "GET", 
            headers: {
                Authorization: `Token ${sessionStorage.token}`,
                "Content-Type": "application/json", 
            },
        })
        const DDC_entry = await response.json();
        const designee_roles = {
            "Report Designee":"report",
            "Comment Redacting Designee":"comment",
            "DDC Designee":"both"
        }
        if (DDC_entry.length){
            if (DDC_entry[0].ROLE.toLowerCase().includes("designee")) {
                setDdcExists(true)
                setAccessLevel(designee_roles[DDC_entry[0].ROLE])
                const [lastName, firstName] = DDC_entry[0].NAME
                    .split(",")
                    .map((name) => name.trim());
                setSearchStatus("")
                setDesigneInfo({
                    empid:DDC_entry[0].EMPID,
                    ccid:DDC_entry[0].CCID,
                    firstName:firstName,
                    lastName:lastName,
                    role:DDC_entry[0].ROLE,
                    dept_id:ddcInfo['dept_id'],
                    faculty:ddcInfo['faculty'],
                    comment_editing:DDC_entry[0].COMMENT_EDITING,
                    ddc:sessionStorage.ccid
                });
                return;
            } else {
                // they must be a dean or chair and cannot be updated from this window
                setDesigneInfo(null)
                setSearchStatus("This CCID already exsits as a Dean or Chair")
                return;
            }
        }
        } catch (error) {
            setDesigneInfo(null)
            setSearchStatus("Unable to search for the requested CCID");
        }
        
        
        try {
            const response = await getLDAPUserBySearchField(
                sessionStorage.getItem("token"),
                "uid",
                designeeCCID
            );

            if (!response || response.ccid === undefined) {
                setDesigneInfo(null)
                setSearchStatus("No information was found for the requested CCID");
                return;
            }
            setSearchStatus("")
            setDesigneInfo({
                empid:response.empid,
                ccid:response.ccid,
                firstName:response.firstName,
                lastName:response.lastName,
                role:null,
                dept_id:ddcInfo['dept_id'],
                faculty:ddcInfo['faculty'],
                comment_editing:"N",
                ddc:sessionStorage.ccid
            });
        } catch (error) {
            setDesigneInfo(null)
            setSearchStatus("Unable to search for the requested CCID");
            // console.error("Search error:", error);
        }
    }
        


    // const handleLDAPSearch = async () => {
    //     try {
    //         const response = await getLDAPUserBySearchField(
    //             sessionStorage.getItem("token"),
    //             "uid",
    //             designeeCCID
    //         );

    //         if (!response || response.ccid === undefined) {
    //             setDesigneInfo(null)
    //             setSearchStatus("No information was found for the requested CCID");
    //             return;
    //         }
    //         setSearchStatus("")
    //         setDesigneInfo({
    //             empid:response.empid,
    //             ccid:response.ccid,
    //             firstName:response.firstName,
    //             lastName:response.lastName,
    //             role:null,
    //             dept_id:ddcInfo['dept_id'],
    //             faculty:ddcInfo['faculty'],
    //             comment_editing:"N",
    //             ddc:sessionStorage.ccid
    //         });
    //     } catch (error) {
    //         setDesigneInfo(null)
    //         setSearchStatus("Unable to search for the requested CCID");
    //         console.error("Search error:", error);
    //     }
    // };

    const handleFirstNameInput = (event) => {
        setDesigneInfo((prev) => ({
            ...prev,
            firstName: event.target.value,
        }));
        setUpdatedValues(true)
    }

    const handleLastNameInput = (event) => {
         setDesigneInfo((prev) => ({
            ...prev,
            lastName: event.target.value,
        }));
        setUpdatedValues(true)
    }

    const handleAccessLevel = (event) => {
        setAccessLevel(event.target.value)
        setUpdatedValues(true)
	};

    const closeDialogPopUp = (evet) => {
        setLoadingMesasge(false)
    }


    async function insertDesignee(){
        setInsertSuccess(false)
        setInsertError(false)
        setLoadingMesasge(true)
        setLoadingWheel(true)

        const accessLevelConfig = {
            comment: {
                role: "Comment Redacting Designee",
                comment_editing: "Y",
            },
            report: {
                role: "Report Designee",
                comment_editing: "N",
            },
            both: {
                role: "DDC Designee",
                comment_editing: "Y",
            },
        };

        const insert_data = {
        ...desgineeInfo,
        ...accessLevelConfig[accessLevel],
        type: "INSERT"
        };
       
        // const response = await fetch(process.env.REACT_APP_BACKEND_HOST.concat("/spot/insert_ddc_designee/"), {
        //     method: "PUT", 
        //     headers: {
        //         Authorization: `Token ${sessionStorage.token}`,
        //         "Content-Type": "application/json", 
        //     },body: JSON.stringify(insert_data),
        // })

        const response = await fetch(process.env.REACT_APP_BACKEND_HOST.concat("/spot/send_designeeRequest_email/"), {
            method: "POST", 
            headers: {
                Authorization: `Token ${sessionStorage.token}`,
                "Content-Type": "application/json", 
            },body: JSON.stringify(insert_data),
        })
        const insert_status = await response.json();

        if (insert_status.status === 200) {
            // Keep loading wheel visible for at least 2 seconds
            await delay(2000);

            // Replace loading wheel with success message
            setLoadingWheel(false);
            setInsertSuccess(true);

            // Keep success message visible for 2 seconds
            await delay(2000);

            window.location.reload();
        } else {
            setLoadingWheel(false);
            setInsertError(true);
        }
    }

    

    async function updateDDCentry(updateType){
        setInsertSuccess(false)
        setInsertError(false)
        setLoadingMesasge(true)
        setLoadingWheel(true)

        const accessLevelConfig = {
            comment: {
                role: "Comment Redacting Designee",
                comment_editing: "Y",
            },
            report: {
                role: "Report Designee",
                comment_editing: "N",
            },
            both: {
                role: "DDC Designee",
                comment_editing: "Y",
            },
        };

        const update_data = {
            ...desgineeInfo,
            ...accessLevelConfig[accessLevel],
            type: updateType
        };

        // const response = await fetch(process.env.REACT_APP_BACKEND_HOST.concat("/spot/updateDDCentry/"), {
        //     method: "PUT", 
        //     headers: {
        //         Authorization: `Token ${sessionStorage.token}`,
        //         "Content-Type": "application/json", 
        //     },body: JSON.stringify(update_data),
        // })

        const response = await fetch(process.env.REACT_APP_BACKEND_HOST.concat("/spot/send_designeeRequest_email/"), {
            method: "POST", 
            headers: {
                Authorization: `Token ${sessionStorage.token}`,
                "Content-Type": "application/json", 
            },body: JSON.stringify(update_data),
        })
        const update_status = await response.json();

       if (update_status.status === 200) {
            // Keep loading wheel visible for at least 2 seconds
            await delay(2000);

            // Replace loading wheel with success message
            setLoadingWheel(false);
            setInsertSuccess(true);

            // Keep success message visible for 5 seconds
            await delay(5000);

            window.location.reload();
        } else {
            setLoadingWheel(false);
            setInsertError(true);
        }
        setUpdatedValues(false)
    }
    

    return(
        <Box
            sx={{ 
                    // border: "2px solid rgba(255, 0, 0, 1)",
                    display: "flex", 
                    flexDirection: "column", 
                    // justifyContent: "center", // vertical centering
                    alignItems: "center",     // horizontal centering
                    minHeight: pageHeight,
                    backgroundColor: "#F5F5F5" ,
                    paddingY:2,
                    paddingX:2,
                }} 
        >
           <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    width: "100%",
                    maxWidth: "56rem", // Tailwind max-w-4xl
                    flexDirection: "column",
                    alignItems: "center",
                    boxShadow: 1,
                    // my: 8,
                    borderRadius: 1,
                    border: "1px solid",
                    borderColor: "divider",
                    backgroundColor: "#fff",
                    // p: 10,
                    p:5,
                    gap:4,
                }}
            >
                
                <Box name ='FORM TITLE'
                    sx={{textAlign: "center"}
                }>
                    <Typography
                        variant="h5"
                        sx={{
                        fontSize: "1.25rem",
                        fontWeight: 500,
                        color: "primary.main",
                        }}
                    >
                        DDC Designee Form
                    </Typography>
                    <Typography sx={{color: "primary.main",fontWeight: 500}}>
                        (New Request)
                    </Typography>
                </Box>
                
                <Box name = 'CCID SEARCH'
                    sx={{
                        
                        display: "flex",flexDirection: "column",
                        paddingX:'10%',
                        width:'100%',
                        gap: 1,
                        // border: "2px solid rgba(255, 0, 0, 1)",
                    }}
                 >
                
                    <InputLabel
                            htmlFor="firstName"
                            sx={{
                                fontWeight: 500,
                                color: "primary.main",
                            }}
                        >
                            Desginee CCID*
                        </InputLabel>
                    <TextField
                        type="text"
                        name="DesigneeCCID"
                        value={designeeCCID}
                        onChange={handleCCIDsearchInput}
                        inputProps={{
                            maxLength: 32,
                        }}
                        fullWidth
                        size="small"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            },
                        }}
                    />
                    <Button 
                        disabled={!designeeCCID}
                        onClick={searchCCID}
                        variant="contained" 
                        sx={{
                            fontWeight: 500,
                            "& .MuiOutlinedInput-root": {
                            borderRadius: 1,
                            },
                        }}>
                            Search CCID
                    </Button>

                    {searchStatus && (
                        <Box
                            sx={{
                                width: "100%",
                                textAlign: "center",
                            }}
                            className="text-red-500"
                        >
                            {searchStatus}
                        </Box>
                    )}
                </Box>
                
                {desgineeInfo && loaded && (
                    <Box name='DESIGNEE INFO'
                        sx={{
                            display: "flex", flexDirection: "column", paddingX:'10%',
                            gap:4,
                            width:'100%',
                            // border: "2px solid rgba(255, 0, 0, 1)",
                    }}>
                        <Box name='FIRST AND LAST NAME'
                            sx={{display: "flex", flexDirection: "row",gap:2,}}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column",width:'50%',gap:1}}>
                                <InputLabel
                                    htmlFor="firstName"
                                    sx={{
                                        fontWeight: 500,
                                        color: "primary.main",
                                    }}
                                >
                                    First Name*
                                </InputLabel>

                                <TextField
                                    id="firstName"
                                    type="text"
                                    name="firstName"
                                    value={desgineeInfo.firstName || ""}
                                    onChange={handleFirstNameInput}
                                    inputProps={{
                                        maxLength: 32,
                                    }}
                                    fullWidth
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column",width:'50%',gap:1 }}>
                                <InputLabel
                                    htmlFor="lastName"
                                    sx={{
                                        fontWeight: 500,
                                        color: "primary.main",
                                    }}
                                >
                                    Last Name*
                                </InputLabel>

                                <TextField
                                    id="lastName"
                                    type="text"
                                    name="lastName"
                                    value={desgineeInfo.lastName || ""}
                                    onChange={handleLastNameInput}
                                    inputProps={{
                                        maxLength: 32,
                                    }}
                                    fullWidth
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                        },
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box name='CCID and EMPID'
                            sx={{display: "flex", flexDirection: "row",gap:2,}}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column",width:'50%',gap:1}}>
                                <InputLabel
                                    htmlFor="firstName"
                                    sx={{
                                        fontWeight: 500,
                                        color: "primary.main",
                                    }}
                                >
                                    CCID*
                                </InputLabel>

                                <TextField
                                    disabled
                                    id="ccid"
                                    type="text"
                                    name="ccid"
                                    value={desgineeInfo.ccid || ""}
                                    onChange={handleCCIDsearchInput}
                                    inputProps={{
                                        maxLength: 32,
                                    }}
                                    fullWidth
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                        },
                                    }}
                                />
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column",width:'50%',gap:1}}>
                                <InputLabel
                                    htmlFor="lastName"
                                    sx={{
                                        fontWeight: 500,
                                        color: "primary.main"
                                    }}
                                >
                                    EMPID*
                                </InputLabel>

                                <TextField
                                    disabled
                                    id="empid"
                                    type="text"
                                    name="empid"
                                    value={desgineeInfo.empid || ""}
                                    onChange={handleCCIDsearchInput}
                                    inputProps={{
                                        maxLength: 32,
                                    }}
                                    fullWidth
                                    size="small"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                        },
                                    }}
                                />
                            </Box>
                        </Box>
                        
                        {(sessionStorage.getItem("access").includes("COMMENT_AUDITING") ||
                         sessionStorage.getItem("access").includes("ADMIN") )&& (
                        <Box name='ACCESS LEVEL'
                            sx={{ display: "flex", flexDirection: "column",width:'100%',gap:1,}} 
                        >
                            <InputLabel
                                htmlFor="firstName"
                                sx={{
                                    fontWeight: 500,
                                    color: "primary.main"
                                }}
                            >
                                ACCESS LEVEL*
                            </InputLabel>
                            <FormControl>
                                <RadioGroup
                                    // defaultValue="report"
                                    name="radio-buttons-group"
                                    value={accessLevel}
                                    onChange={handleAccessLevel}
                                >
                                    <FormControlLabel value="report" control={<Radio />} 
                                        label="DDC Report Access" />
                                    <FormControlLabel value="comment" control={<Radio />} 
                                        label="Comment Redacting Access" />
                                    <FormControlLabel value="both" control={<Radio />} 
                                        label="DDC Report & Comment Redacting Access" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                        )}
                       
                        <Box name='SUBMIT BUTTON'
                            sx={{ display: "flex", flexDirection: "column",width:'100%'}}>
                            {!ddcExists && (
                                <Button 
                                    disabled={!accessLevel}
                                    onClick={insertDesignee}
                                    variant="contained" 
                                    sx={{
                                        fontWeight: 500,
                                        "& .MuiOutlinedInput-root": {
                                        borderRadius: 1,
                                        },
                                    }}>
                                        CREATE
                                </Button>
                            )}

                            {ddcExists && (
                                <Box sx={{ display: "flex",flexDirection: "column",width:'100%',gap: 1}}>
                                    <Button 
                                        disabled={!updatedValues}
                                        onClick={() => updateDDCentry("UPDATE")}
                                        variant="contained" 
                                        sx={{
                                            fontWeight: 500,
                                            "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                            },
                                        }}>
                                            UPDATE
                                    </Button>
                                    <Button 
                                        color="error"
                                        // disabled={!accessLevel}
                                        onClick={() => updateDDCentry("DELETE")}
                                        variant="contained" 
                                        sx={{
                                            fontWeight: 500,
                                            "& .MuiOutlinedInput-root": {
                                            borderRadius: 1,
                                            },
                                        }}>
                                            DELETE
                                    </Button>
                                </Box>
                                
                        )}
                        </Box>

                        <Dialog class="Edit Warning" open={loadingMessage} fullWidth={true} maxWidth={"lg"}>
                            <DialogContent sx={{
                                pb:5,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                // gap: 1,
                                // border: "2px solid rgba(255, 0, 0, 1)",
                            }}>
                                <DialogTitle id="alert-dialog-title">
                                    PROCESSING THE REQUESTED ACTION
                                </DialogTitle>
                                {insertError && (
                                    <IconButton
                                        aria-label="close"
                                        onClick={closeDialogPopUp}
                                        sx={(theme) => ({
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: theme.palette.grey[500],
                                        })}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                )}
                                {loadingWheel && (
                                    <CircularProgress enableTrackSlot color="primary" size={50} thickness={5}/>
                                )}

                                {insertSuccess && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            textAlign: "center",
                                            alignItems:"center",
                                            gap:2
                                        }}
                                    >    
                                        <CheckCircleIcon color="primary" fontSize="large"/>
                                        {/* <Typography>ACTION COMPLETED SUCCESSFULLY</Typography> */}
                                        <Typography>YOUR REQUEST HAS SUCCESSFULLY BEEN SUBMITTED</Typography>
                                        <Typography>PLEASE ALLOW 1-2 BUSINESS DAYS IN ORDER TO TAKE EFFECT</Typography>
                                       
                                    </Box>
                                )}

                                {insertError && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            textAlign: "center",
                                            alignItems:"center",
                                            gap:2
                                        }}
                                        className="text-red-500"
                                    >    
                                        <ErrorIcon color="error" fontSize="large"/>
                                        <Typography>UNABLE TO COMPLETE THE REQUESTED ACTION</Typography>
                                        <Typography>Support can be reached by emailing test.scoring@ualberta.ca or calling 780.492.2741</Typography>
                                    </Box>
                                )}
                            </DialogContent>
                        </Dialog>
                       
                    </Box>

                    
                )}
            </Box>

        </Box>
    );
}